import type { PublicLeaderboard } from '../../../domain/leaderboard/models/public-leaderboard.model';
import type { MappedOverview } from './map-overview-api-to-domain';
import type { MappedRanking } from './map-ranking-api-to-domain';
import type { LeaderboardRankingRow } from '../../../domain/leaderboard/models/public-leaderboard.model';

export function composePublicLeaderboard(
  overview: MappedOverview,
  ranking: MappedRanking,
  selfRow: LeaderboardRankingRow | null,
): PublicLeaderboard {
  return {
    boardId: overview.boardId,
    title: overview.title,
    status: overview.status,
    activityType: overview.activityType,
    summary: overview.summary,
    prizes: overview.prizes,
    podium: ranking.podium,
    ranking: ranking.ranking,
    lastUpdatedIso: overview.lastUpdatedIso,
    footerHint: 'Actualizado en tiempo real',
    branding: overview.branding,
    logoUrl: overview.logoUrl,
    termsAndConditionsUrl: overview.termsAndConditionsUrl,
    selfRow: selfRow ?? undefined,
  };
}
